import { useMemo } from 'react';
import { useLocaleKeys } from '~/i18n';
export const useTableColumnMenu = (tableBiName)=>{
    const { t: columnMenuTexts } = useLocaleKeys('common.tableColumnMenu');
    return useMemo(()=>({
            labels: {
                sortAscending: columnMenuTexts.sortAscending(),
                sortDescending: columnMenuTexts.sortDescending(),
                freeze: columnMenuTexts.freeze(),
                unfreeze: columnMenuTexts.unfreeze(),
                hide: columnMenuTexts.hide()
            },
            bi: {
                trigger: {
                    name: "".concat(tableBiName, "_column_menu")
                },
                sortAscending: {
                    name: "".concat(tableBiName, "_column_sort_ascending")
                },
                sortDescending: {
                    name: "".concat(tableBiName, "_column_sort_descending")
                },
                freeze: {
                    name: "".concat(tableBiName, "_column_freeze")
                },
                hide: {
                    name: "".concat(tableBiName, "_column_hide")
                }
            }
        }), [
        tableBiName
    ]);
};
